<template>
    <Vue100vh class="tivoli">
        <CircleWrap @click.native="$router.push('/')" type="back">
            <BackIconThin/>
        </CircleWrap>
        <div class="tent"></div>
        <div class="grass"></div>
        <div class="inner-wrap">
            <div class="wheel">
	            <AsyncResource resource="/assets/tivoli/animation/wheel_2.json" v-slot:default="props">
		            <lottie v-if="!isTransitioning && props.resourceFetched && props.data !== null" :options="{animationData: props.data,autoplay: false,loop: false}" :height="441" :width="418" v-on:animCreated="handleAnimation($event,'wheel')"/>
		            <img v-else src="/assets/tivoli/wheel.svg" :height="441" :width="418">
	            </AsyncResource>
	            <CssLoader v-if="isTransitioning"/>
                <transition name="fade">
                    <button v-if="!isTransitioning && !isSpinning" :class="{'is-up': buttonIsUp}" @click="spin">
                        <span>Spin lykkehjulet</span>
                        <span class="spins">{{spinTokens.length}} spins</span>
                    </button>
                </transition>
            </div>
            <div class="tonni">
                <div class="tonni-holder">
	                <AsyncResource resource="/assets/tivoli/animation/tonni-final.json" v-slot:default="props">
		                <lottie v-if="isTransitioning === false && props.resourceFetched && props.data !== null" :options="{animationData: props.data,autoplay: false,loop: false}" :height="620" :width="400" v-on:animCreated="handleAnimation($event,'tonni')"/>
		                <div v-else style="width: 400px; height: 620px; overflow: hidden; margin: 0px auto;"><img src="/assets/tivoli/tonni.svg" :height="620" :width="400"></div>
	                </AsyncResource>
                </div>
                <div class="confetti-holder">
	                <AsyncResource resource="/assets/tivoli/animation/confetti.json" v-slot:default="props">
		                <lottie v-if="isTransitioning === false && props.resourceFetched && props.data !== null" :options="{animationData: props.data,autoplay: false,loop: false}" :height="800" :width="800" v-on:animCreated="handleAnimation($event,'confetti')"/>
	                </AsyncResource>
                </div>
                <transition name="fade">
                    <Bubble v-if="showBubble" angle="right">Du har desværre ikke flere spins.</Bubble>
                </transition>
            </div>
        </div>
        <Popup mode="tivoli" :open="popup.open" @closePopup="popup.open = false ">
            <p>Juhuu, der var en præmie til dig.</p>
            <div class="winnings">Du har vundet {{popup.type}}</div>
            <p class="small">Præmien kan afhentes i Vorbasse – Nærmere information følger på email. Fortsat godt marked :)</p>
            <button @click="closePopup">Jubii!</button>
        </Popup>
    </Vue100vh>
</template>
<script>
	import Lottie from 'vue-lottie'

	import Vue100vh from 'vue-div-100vh'
    import gsap from 'gsap'

    import Popup from "@/components/popup/Popup"
    import Bubble from "@/components/Bubble"
	import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
	import {mapState} from "vuex";
	import {validateObjectStructure} from "@/helperFunctions";
	import AsyncResource from "@/components/resources/AsyncResource";
	import CssLoader from "@/components/CssLoader";
	export default {
		name: "Tivoli.vue",
		components: {
			CssLoader,
			Lottie,
            Vue100vh,
			Popup,
			Bubble,
			CircleWrap,
			BackIconThin,
			AsyncResource
		},
        data(){
			return{
				isPerformingSpin: false,
				isSpinning: true,
				buttonIsUp: false,
                showBubble: false,
				popup: {
					open: false,
                    type: ''
                },
                segments: {
					wheel: [
                	    [0,252],[264,450],[452,664],[690,896],[912,1068],[1084,1276],[1286,1452],[1468,1632] // Gevinst,nitte,bamse,billetter,nitte,bamse,nitte,øv
                    ],
                    tonni: [
	                    [24,64],[72,112],[120,156] // Vinder, boogie, øv
                    ]
                },
				animationSpeed: 1,
                anims: {
					wheel: false,
                    tonni: false,
                    confetti: false
                },
				isTransitioning:true
            }
        },
        mounted(){
			let that = this
            // Animation
	        let tl = gsap.timeline();
	        tl.to(".tivoli .grass", {y: 0, duration: 0.5});
	        tl.to(".tivoli .tent", {x: 0, duration: 0.5});
	        tl.to(".tivoli .wheel", {x: 0, opacity: 1, duration: 0.3});
	        tl.to(".tivoli .tonni", {x: 0, opacity: 1, duration: 0.3});
	        tl.to(".tivoli .circle", {x: 0, opacity: 1, duration: 0.5, onComplete:function() {
                that.isSpinning = false;
                that.isTransitioning = false;
            }});

        },
		computed: {
			...mapState('vorbasse', {
				spinTokens: 'spinTokens'
			}),
		},
        methods: {
	        handleAnimation: function (event,type) {
		        this.anims[type] = event;
	        },
	        play(type){
	        	if(type === 'wheel'){
			        this.anims[type].play();
			        this.isSpinning = true
                }else if(type === 'tonni'){
			        this.anims[type].goToAndPlay(0);
                }
            },
	        performSpin(result){
	        	const that = this;
		        let segment = false;
		        let segmentT = false;
		        let segmentTHolder = false;
		
		        switch (result)
		        {
			        case 'bamse':
				        let bamseOptions = [2, 5]
				        let randomBamseNumber = Math.floor(Math.random() * bamseOptions.length)
				        segment = that.segments.wheel[bamseOptions[randomBamseNumber]]
				        segmentTHolder = 0
				        break
			        case 'billetter':
				        segment = that.segments.wheel[3]
				        segmentTHolder = 0
				        break
			        case 'toblerone':
				        segment = that.segments.wheel[0]
				        segmentTHolder = 0
				        break
			        case 'spins':
				        segment = that.segments.wheel[0]
				        segmentTHolder = 0
				        break
			        case 't-shirt':
				        segment = that.segments.wheel[0]
				        segmentTHolder = 0
				        break
			        default:
				        let nitteOptions = [1, 4, 6, 7]
				        let randomNitteNumber = Math.floor(Math.random() * nitteOptions.length)
				        segment = that.segments.wheel[nitteOptions[randomNitteNumber]]
				        segmentTHolder = 2
				        break
		        }
		        that.popup.type = result
		
		        // Set wheel animation
		        that.anims.wheel.playSegments(segment, true)
		        that.isSpinning = true
		        let timeout = (segment[1] - segment[0]) / 24 * 1000
		
		        // Handle Tonni animation
		        setTimeout(function ()
		        {
			        segmentT = that.segments.tonni[1]
			        that.anims.tonni.playSegments(segmentT, true)
			        segmentT = that.segments.tonni[segmentTHolder]
		        }, 2500);
		
		        setTimeout(function ()
		        {
			        that.anims.tonni.playSegments(segmentT, true)
			        if (result !== 'nitte')
			        {
				        // Confetti delay
				        setTimeout(function ()
				        {
					        that.anims.confetti.goToAndPlay(0)
				        }, 500)
				        // Tonni delay
				        setTimeout(function ()
				        {
					        that.popup.open = true
				        }, 1500)
			        }
			        that.isSpinning = false
			        that.isPerformingSpin = false
		        }, timeout)
	        },
			spin(){

	        	if(this.spinTokens.length === 0 || this.spinTokens === false){
	        		this.showBubble = true;
                    this.isSpinning = true;
	        		return false;
                }

	        	if(this.isPerformingSpin === false)
		        {
		        	this.isPerformingSpin = true;
			        let that = this;

			        this.buttonIsUp = true;
			        setTimeout(function ()
			        {
				        that.buttonIsUp = false
			        }, 1000);


			        let token = this.spinTokens[this.spinTokens.length - 1]
			        this.performSpin('billetter');
			        return;
			        this.$store.dispatch('vorbasse/performTivoliSpin', token)
			        .then(result =>
			        {
				       that.performSpin(result);
			        })
			        .catch(error => {
				        that.isPerformingSpin = false;
						if(validateObjectStructure(error,['is_authenticated','status']))
						{
							if(error['is_authenticated'] === false)
							{
								//Forsøgt at bruge en andens token / er ikke logget ind
								that.$store.dispatch('vorbasse/showPrompt',{
									title: 'Fejl',
									prompt: 'Der skete en fejl under spinnet. Prøv igen eller kontakt en medarbejder',
									confirmText: 'Ok - forstået',
									showCancelButton: false
								});
							}
							else
							{
								if(typeof error.reason !== 'undefined')
								{
									that.performSpin('nitte');
								}
								else
								{
									// ? ukendt
									that.$store.dispatch('vorbasse/showPrompt',{
										title: 'Fejl',
										prompt: 'Der skete en fejl under spinnet. Prøv igen eller kontakt en medarbejder',
										confirmText: 'Ok - forstået',
										showCancelButton: false
									});
								}
							}
						}
			        })
		        }
            },
            closePopup(){
	            this.popup.open = false
	            this.popup.type = ''
            }
        }
	}
</script>
<style lang="scss" scoped>

    // Animation presets
    .tivoli{
        .grass{
            transform: translateY(100%);
        }
        .tent{
            transform: translateX(100%);
        }
        .wheel{
            transform: translateX(-200px);
            opacity: 0;
        }
        .tonni{
            transform: translateX(200px);
            opacity: 0;
        }
    }

    .tivoli{
        background: $sky;
        position: fixed;
        width: 100vw;
        top: 0; left: 0;
        .circle{
            background: $white;
            position: absolute;
            top: 15px;
            left: 15px;
            z-index: 1;
            svg{
                transform: translate(-70%, -50%);
            }
        }
        .inner-wrap{
            position: absolute;
            width: 500px;
            bottom: 20vh;
            left: 50vw;
            transform: translateX(-60%);
            @media(max-width: 767px) and (min-height: 800px){
                bottom: 15vh;
            }
            @media(max-width: 767px) and (max-height: 800px){
                bottom: 5vh;
            }

            @media(orientation: landscape) and (max-height: 450px){
                transform: translate(-55%, 200px) scale(0.95);
                transform-origin: center center;
            }
	        .css-loader{
		        position: absolute;
		        top:50%;
		        left:50%;
		        transform: translate(-50%,-50%);
		        margin-top:9px;
	        }
            .wheel{
                position: absolute;
                bottom: 10vh;
                left: 0px;
                width: 418px;
                height: 441px;
	            .loader{
		            position: absolute;
		            top:50%;
		            left:50%;
		            transform: translate(-50%,-50%);
		            margin-top: 9px;
	            }
                button{
                    display: block;
                    width: 156px;
                    height: 156px;
                    border-radius: 50%;
                    border: 3px solid $white;
                    background: $green;
                    text-align: center;
                    padding-top: 25px !important;
                    box-shadow: 0px 2px 25px rgba(0,0,0,0.5);
                    position: absolute;
                    top: 148px;
                    left: 130px;
                    cursor: pointer;
                    text-transform: none;
                    z-index: 5;
                    &:focus{
                        transform: scale(0.9);
                    }
                    &.is-up{
                        transform: scale(1) !important;
                    }
                    span{
                        display: block;
                        font-size: 20px;
                        font-weight: bold;
                        margin-bottom: 17px;
                        color: $white;
                        &.spins{
                            color: $dark;
                            font-size: 14px;
                            margin-bottom: 0px;
                        }
                    }
                }
            }
            .tonni{
                position: absolute;
                bottom: 0px;
                right: 0px;
                width: 148px;
                height: 524px;
                pointer-events: none;
                .tonni-holder{
                    position: absolute;
                    bottom: 20px;
                    left: -141px;
                }
                .confetti-holder{
                    position: absolute;
                    bottom: -90px;
                    right: -190px;
                    width: 800px;
                    height: 800px;
                }
                .bubble{
                    position: absolute;
                    top: 65px;
                    left: -185px;
                }
            }
        }
        .tent{
            position: absolute;
            top: 0px;
            right: 0px;
            width: calc(50vw - 27px);
            height: 74vh;
            background-color: $white;
            background-image: linear-gradient(90deg, transparent 50%, #C76875 50%);
            background-size: 108px;
            @media(max-width: 767px) and (max-height: 800px){
                height: 85vh;
            }
        }
        .grass{
            position: absolute;
            bottom: 0px;
            left: 0px;
            width: 100%;
            height: 26vh;
            background: $green;
            @media(max-width: 767px) and (max-height: 800px){
                height: 15vh;
            }
        }
    }
</style>
